export default __webpack_public_path__ + "static/media/cash.335247cb.jpg";